import React from "react";

import type { AuditEntitySlug } from "./auditTypes";
import ActionLink from "../controls/ActionLink";
import { buildAuditUrl } from "./auditEntityConfig";

type AuditActionLinkProps = {
  slug: AuditEntitySlug;
  id: number | string;
  name?: string | null;
  className?: string;
};

export default function AuditActionLink({
  slug,
  id,
  name,
  className = "",
}: AuditActionLinkProps) {
  return (
    <ActionLink
      variant="primary"
      to={buildAuditUrl(slug, id, name)}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
    >
      Audit
    </ActionLink>
  );
}
